import React from 'react'
import { Breadcrumbs, Grid, Typography } from '@mui/material'
import { useThemeStyles } from '@shared/theme/use-theme-styles'
import { AuditRequirementResponse, Roles, Status } from '@shared/types'
import { StatusText } from '@shared/utils/get-status-text'
import { useIsClientBasic } from '@shared/hooks/use-is-client-basic'
import { ShowConditionally } from '@shared/components/show-conditionally.component'
import { StatusContainer } from './status-container.component'
import { useACL } from '@shared/hooks/use-acl.hook'

interface Props {
  requirement: AuditRequirementResponse
  statuses: Status[]
  isAudit?: boolean
}

export const RequirementHeader = ({
  requirement,
  statuses,
  isAudit,
}: Props) => {
  const { is } = useACL()
  const isClientBasic = useIsClientBasic()
  const themeClasses = useThemeStyles()

  const statusContainerContent = [
    {
      title: 'Status audytora',
      role: 'auditor',
    },
    {
      title: is([Roles.Client, Roles.ClientAdministrator, Roles.ClientEditor])
        ? 'Moja ocena'
        : 'Ocena specjalisty',
      role: 'client',
    },
  ]

  return (
    <Grid
      container
      className={themeClasses.detailsContainer}
      justifyContent="space-between"
    >
      <Grid>
        <h1 className={themeClasses.detailsHeader}>{requirement.name}</h1>
        <Breadcrumbs className={themeClasses.detailsBreadcrumbsContainer}>
          {requirement.scopeName && (
            <Typography className={themeClasses.detailsBreadcrumbsItem}>
              {requirement.scopeName}
            </Typography>
          )}
          {requirement.groupName && (
            <Typography className={themeClasses.detailsBreadcrumbsItem}>
              {requirement.groupName}
            </Typography>
          )}
        </Breadcrumbs>
      </Grid>
      <ShowConditionally when={!isClientBasic && isAudit}>
        <Grid>
          {statusContainerContent.map((content) => (
            <StatusContainer
              key={content.role}
              requirement={requirement}
              role={content.role as keyof StatusText}
              title={content.title}
              statuses={statuses}
            />
          ))}
        </Grid>
      </ShowConditionally>
    </Grid>
  )
}
